// extracted by mini-css-extract-plugin
export default {"adWrapper":"adWrapper__wyYEs","adLabel":"adLabel__z71Os","adContainer":"adContainer__MVjO7","closeButton":"closeButton__5C1MB","adLink":"adLink__LGlau","adImage":"adImage__QP+am"};